module.exports = __webpack_public_path__ + "static/img13-465b4d0e50f051fb2806020bf1bcd957.jpg";